<!--
 * @Author: your name
 * @Date: 2020-08-04 12:07:07
 * @LastEditTime: 2020-08-05 17:56:05
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Web\JiYun.Mobile\src\views\threeDimensional\index.vue
-->
<template>
    <div class="threeDimensional">
        <van-nav-bar
            title="三维场站"
            left-text=""
            left-arrow
            @click-left="onClickLeft"
        >
            <template #right>
                <van-dropdown-menu v-if="showStation">
                    <van-dropdown-item
                        v-model="station"
                        :options="stationList"
                        @change="changeStation"
                    ></van-dropdown-item>
                </van-dropdown-menu>
            </template>
        </van-nav-bar>
        <div class="iframe-con">
            <iframe id="threeDimensional" :src="url" v-show="show3d"></iframe>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
        return {
            url: '',
            show3d: false,
            station: '',
            stationList: [],
            showStation: false,
        };
    },
    watch: {},
    computed: {},
    created() {},
    mounted() {
        this.getOrg();
    },
    methods: {
        // 返回
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 更换场站
        async changeStation() {
            const info = await this.get3dinfoApi(this.station);
            if (info) {
                this.url = info[0].url_address;
                this.show3d = true;
            }
        },
        // 处理场站数据
        async getOrg() {
            const res = await this.getOrgApi();
            if (res) {
                res.map(item => {
                    this.stationList.push({ text: item.org_name, value: item.tree_id });
                });
                if (this.stationList.length > 1) {
                    this.showStation = true;
                }
                this.station = this.stationList[0].value;
                const treeid = res[0].tree_id;
                const info = await this.get3dinfoApi(treeid);
                if (info) {
                    this.url = info[0].url_address;
                    this.show3d = true;
                }
            }
        },
        // 获取租户三维信息
        get3dinfoApi(treeid) {
            const path = '/interfaceApi/tenant/tenant3dinfo/get3dinfo/' + this.$takeTokenParameters('TenantId') + '/' + treeid;
            return this.$axios.$get(path, { defEx: true });
        },
        // 获取场站api
        getOrgApi() {
            const path = '/interfaceApi/tenant/tenant3dinfo/get/tenant_id/' + this.$takeTokenParameters('TenantId');
            return this.$axios.$get(path, { defEx: true });
        },
    },
};
</script>
<style lang="stylus">
.threeDimensional
    height 100%
    .iframe-con
        height calc(100% - 45rpx)
        iframe
            width 100%
            height 100%
            border none
    .van-dropdown-menu
        background #101077
        height 46rpx
        .van-dropdown-menu__title
            color #fff
    .van-hairline--top-bottom
        &:after
            border-width 0
</style>